import {useEffect, useMemo} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function EncounterTeam({ data }) {
    const encounterTeamChart = useMemo(() => {
        const source = data?.encountersByTeams || [];

        return {
            labels: source.map(item => item.team),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    useEffect(() => {
        GraphicUtils.barChart(
            "encounter-team",
            encounterTeamChart.values,
            encounterTeamChart.labels,
        );

        if (encounterTeamChart.values.some(v => v > 0)) {
            ReportUtils.createExportableTable(
                encounterTeamChart.labels,
                encounterTeamChart.values,
                "Abordagens por equipe",
            );
        }
    }, [encounterTeamChart]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Abordagens por equipe</span>
                <div className="mt-3" id="encounter-team" />
            </div>

            <div className="chart-divisor" />
        </>
    )
}